"use client";

import { useEffect } from "react";
import { tracker } from "@/lib/tracker";

export const UserIdentifier = ({ id, email }: { id?: string; email?: string }) => {
  useEffect(() => {
    tracker?.identify({
      id,
      email,
    });
  }, [id, email]);

  return null;
};